var render = function render(){var _vm=this,_c=_vm._self._c;return _c('show-admins',{ref:"registerAdmin",attrs:{"is-me":false,"is-deps":false,"title":'Εμφάνιση Διαχειριστών ΓΕΣ/Α4 (ΔΕΠΕΘ)'}})
}
var staticRenderFns = []

export { render, staticRenderFns }